<div
    class="create-page-shell"
    [class.chat-open]="lyricsChatOpen"
    [class.chat-resizing]="lyricsChatResizing"
    [style.--lyrics-chat-width]="lyricsChatWidth + 'px'">
    <main class="create-container">
        <div class="create-form">
            <div
                class="output-mode-selector"
                [class.selection-score]="outputMode === 'score'"
                role="radiogroup"
                aria-label="Generation type">
                <button
                    type="button"
                    role="radio"
                    [class.selected]="outputMode === 'audio'"
                    [attr.aria-checked]="outputMode === 'audio'"
                    (click)="setOutputMode('audio')">
                    Audio generation
                </button>
                <button
                    type="button"
                    role="radio"
                    [class.selected]="outputMode === 'score'"
                    [attr.aria-checked]="outputMode === 'score'"
                    (click)="setOutputMode('score')">
                    Score generation
                </button>
            </div>

            <div class="input-prompt-wrapper">
                <div class="prompt-header">
                    <label
                        class="prompt-title field-label"
                        for="music-description"
                        [tooltip]="
                            'Describe the music you want AIVA to create.'
                        "
                        [tooltip-position]="'middle-bottom'"
                        [tooltip-marginTop]="8"
                        [tooltip-width]="220">
                        Prompt
                        <img
                            class="field-tooltip-icon"
                            src="assets/img/info.svg"
                            alt=""
                            aria-hidden="true" />
                    </label>
                </div>

                <textarea
                    id="music-description"
                    class="music-prompt-textarea"
                    [placeholder]="promptPlaceholder"
                    [(ngModel)]="prompt"
                    [maxlength]="promptMaxLength"
                    spellcheck="true"></textarea>
                <span class="textarea-resize-icon" aria-hidden="true"></span>
            </div>

            <div class="lyrics-panel" [class.lyrics-disabled]="!lyricsEnabled">
                <div class="lyrics-header">
                    <div class="lyrics-heading-row">
                        <div class="lyrics-title-with-toggle">
                            <label
                                class="lyrics-title field-label"
                                [attr.for]="
                                    lyricsEnabled ? 'lyrics-input' : null
                                "
                                [tooltip]="
                                    'Write your own lyrics or use the lyrics assistant to generate them.'
                                "
                                [tooltip-position]="'middle-bottom'"
                                [tooltip-marginTop]="8"
                                [tooltip-width]="240">
                                Lyrics
                                <img
                                    class="field-tooltip-icon"
                                    src="assets/img/info.svg"
                                    alt=""
                                    aria-hidden="true" />
                            </label>
                            <slide-toggle
                                class="grey-toggle"
                                width="36px"
                                [toggled]="lyricsEnabled"
                                (onChange)="setVocalsIncluded($event)"
                                avData="lyrics-enabled-toggle"></slide-toggle>
                        </div>
                        <button
                            *ngIf="lyricsEnabled"
                            type="button"
                            class="mobile-lyrics-settings-button"
                            aria-label="Lyrics settings"
                            aria-haspopup="menu"
                            [attr.aria-expanded]="lyricsSettingsMenuOpen"
                            (click)="toggleLyricsSettingsMenu()">
                            <img
                                src="assets/img/pianoroll/settings.svg"
                                alt=""
                                aria-hidden="true" />
                        </button>
                        <div
                            class="lyrics-header-actions"
                            *ngIf="lyricsEnabled">
                            <button
                                type="button"
                                class="generate-lyrics-button"
                                aria-label="Generate lyrics"
                                (click)="openLyricsChat()">
                                <img
                                    src="assets/img/navbar/generative_sparkles.svg"
                                    alt=""
                                    aria-hidden="true" />
                                <span>Generate lyrics</span>
                            </button>

                            <div
                                class="vocal-gender-selector"
                                [class.selection-auto]="vocalGender === ''"
                                [class.selection-female]="
                                    vocalGender === 'female'
                                "
                                [class.selection-male]="vocalGender === 'male'"
                                role="group"
                                aria-label="Vocal gender">
                                <button
                                    type="button"
                                    [class.selected]="vocalGender === ''"
                                    [attr.aria-pressed]="vocalGender === ''"
                                    (click)="setVocalGender('')">
                                    Auto
                                </button>
                                <button
                                    type="button"
                                    [class.selected]="vocalGender === 'female'"
                                    [attr.aria-pressed]="
                                        vocalGender === 'female'
                                    "
                                    (click)="setVocalGender('female')">
                                    Female
                                </button>
                                <button
                                    type="button"
                                    [class.selected]="vocalGender === 'male'"
                                    [attr.aria-pressed]="vocalGender === 'male'"
                                    (click)="setVocalGender('male')">
                                    Male
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="lyrics-input-wrapper" *ngIf="lyricsEnabled">
                    <textarea
                        id="lyrics-input"
                        [(ngModel)]="lyrics"
                        [placeholder]="lyricsPlaceholder"
                        [maxlength]="lyricsMaxLength"
                        spellcheck="true"></textarea>
                    <span
                        class="textarea-resize-icon"
                        aria-hidden="true"></span>
                </div>
            </div>

            <div class="generate-button-row">
                <div class="composition-count-control">
                    <span
                        class="composition-count-label field-label"
                        [tooltip]="
                            'Controls how many tracks to generate in parallel.'
                        "
                        [tooltip-position]="'middle-bottom'"
                        [tooltip-marginTop]="8"
                        [tooltip-width]="220">
                        Tracks
                        <img
                            class="field-tooltip-icon"
                            src="assets/img/info.svg"
                            alt=""
                            aria-hidden="true" />
                    </span>
                    <div
                        class="composition-count-selector"
                        role="radiogroup"
                        aria-label="Number of tracks">
                        <button
                            type="button"
                            role="radio"
                            [class.selected]="numCompositions === 1"
                            [attr.aria-checked]="numCompositions === 1"
                            (click)="setNumCompositions(1)">
                            1 track
                        </button>
                        <button
                            type="button"
                            role="radio"
                            [disabled]="maxParallelTracks < 2"
                            [class.selected]="numCompositions === 2"
                            [attr.aria-checked]="numCompositions === 2"
                            (click)="setNumCompositions(2)">
                            2 tracks
                        </button>
                    </div>
                </div>

                <div class="magic-button-wrapper">
                    <div
                        class="generation-error"
                        role="alert"
                        *ngIf="generationError">
                        {{ generationError }}
                    </div>
                    <magic-button
                        *ngIf="!createLoading"
                        [title]="'Create your song'"
                        [fullWidth]="true"
                        [showIcon]="false"
                        [disabled]="prompt.trim().length === 0"
                        fontSize="95%"
                        (onClick)="generateTrack($event)"></magic-button>
                    <div
                        *ngIf="createLoading"
                        class="creating-song-indicator"
                        role="status"
                        aria-live="polite">
                        Creating your song
                    </div>
                    <div class="generate-model-attribution">
                        Powered by Minimax Music 3
                    </div>
                </div>
            </div>
        </div>
    </main>

    <menu-options
        *ngIf="
            lyricsEnabled && lyricsSettingsMenuOpen && lyricsSettingsMenuOptions
        "
        [menuOptions]="lyricsSettingsMenuOptions"
        title="Lyrics settings"
        (close)="closeLyricsSettingsMenu()"></menu-options>

    <div
        *ngIf="lyricsChatOpen"
        class="lyrics-chat-resize-handle"
        [class.dragging]="lyricsChatResizing"
        role="separator"
        tabindex="0"
        aria-label="Resize lyrics assistant"
        aria-orientation="vertical"
        [attr.aria-valuemin]="lyricsChatMinWidth"
        [attr.aria-valuemax]="lyricsChatMaxWidth"
        [attr.aria-valuenow]="lyricsChatWidth"
        (pointerdown)="onLyricsChatResizePointerDown($event)"
        (pointermove)="onLyricsChatResizePointerMove($event)"
        (pointerup)="onLyricsChatResizePointerUp($event)"
        (pointercancel)="onLyricsChatResizePointerCancel()"
        (keydown)="onLyricsChatResizeKeydown($event)"></div>

    <lyrics-chat
        [class.open]="lyricsChatOpen"
        [open]="lyricsChatOpen"
        [musicDescription]="prompt"
        [currentLyrics]="lyrics"
        [vocalGender]="vocalGender"
        (close)="closeLyricsChat()"
        (useLyrics)="applyGeneratedLyrics($event)"></lyrics-chat>
</div>
